/**
 * Numele porturilor TCP, ca in `TcpPortMatch` din
 * `public/js/easeedesk/easeedesk.js:7116`. Mutata ca atare, cu tot cu greselile
 * de tipar din ea ("Word of Warcreaft", "Interbase BD"): panoul vechi si cel nou
 * trebuie sa scrie ACELASI lucru pe aceeasi masina, iar o indreptare aici s-ar
 * vedea ca o nepotrivire intre ele, nu ca o reparatie.
 *
 * Un port necunoscut nu primeste nume - si atunci panoul il scrie cu rosu, ca
 * in portal: nu se stie ce vorbeste pe el.
 */
export const TCP_PORTS: Record<number, string> = {
  7: 'Echo',
  19: 'Chargen',
  20: 'FTP',
  21: 'FTP',
  22: 'SSH/SCP',
  23: 'Telnet',
  25: 'SMTP',
  42: 'WINS Replication',
  43: 'WHOIS',
  49: 'TACACS',
  53: 'DNS',
  67: 'DHCP/BOOTP',
  68: 'DHCP/BOOTP',
  69: 'TFTP',
  70: 'Gopher',
  79: 'Finger',
  80: 'HTTP',
  88: 'Kerberos',
  102: 'MS Exchange',
  110: 'POP3',
  113: 'Ident',
  119: 'NNTP',
  123: 'NTP',
  135: 'Microsoft RPC',
  137: 'NetBIOS',
  138: 'NetBIOS',
  139: 'NetBIOS',
  143: 'IMAP4',
  161: 'SNMP',
  162: 'SNMP',
  177: 'XDMCP',
  179: 'BGP',
  201: 'AppleTalk',
  264: 'BGMP',
  318: 'TSP',
  381: 'HP Openview',
  382: 'HP Openview',
  383: 'HP Openview',
  389: 'LDAP',
  411: 'Direct Connect',
  412: 'Direct Connect',
  443: 'HTTPS',
  445: 'Microsoft DS',
  464: 'Kerberos',
  465: 'SMTP over SSL',
  497: 'Retrospect',
  500: 'ISAKMP',
  512: 'rexec',
  513: ' rlogin',
  514: 'syslog',
  515: 'LPD/LPR',
  520: 'RIP',
  521: 'RIPng(IPv6)',
  540: 'UUCP',
  546: 'DHCPv6',
  547: 'DHCPv6',
  554: 'RTSP',
  560: 'rmonitor',
  563: 'NNTP over SSL',
  587: 'SMTP',
  591: 'FileMaker',
  593: 'Microsoft DCOM',
  631: 'Internet Printing',
  636: 'LDAP over SSL',
  639: 'MSDP (PIM)',
  646: 'LDP (MPLS)',
  691: 'MS Exchange',
  860: 'iSCSI',
  873: 'rsync',
  902: 'VMware Server',
  989: 'FTP over SSL',
  990: 'FTP over SSL',
  993: 'IMAP4 over SSL',
  995: 'POP3 over SSL',
  1025: 'Microsoft RPC',
  1026: 'Windows Messenger',
  1027: 'Windows Messenger',
  1028: 'Windows Messenger',
  1029: 'Windows Messenger',
  1080: 'MyDoom',
  1194: 'OpenVPN',
  1214: 'Kazaa',
  1241: 'Nessus',
  1311: 'Dell OpenManage',
  1337: 'WASTE',
  1433: 'Microsoft SQL',
  1434: 'Microsoft SQL',
  1512: 'WINS',
  1589: 'Cisco VQP',
  1701: 'L2TP',
  1723: 'MS PPTP',
  1725: 'Steam',
  1741: 'CiscoWorks 2000',
  1755: 'MS Media Server',
  1812: 'RADIUS',
  1813: 'RADIUS',
  1863: 'MSN',
  1985: 'Cisco HSRP',
  2000: 'Cisco SCCP',
  2002: 'Cisco ACS',
  2049: 'NFS',
  2082: 'cPanel',
  2083: 'cPanel',
  2100: 'Oracle XDB',
  2222: 'DirectAdmin',
  2302: 'Halo',
  2483: 'Oracle DB',
  2484: 'Oracle DB',
  2745: 'Bagle.H',
  2967: 'Symantec AV',
  3050: 'Interbase BD',
  3074: 'XBOX Live',
  3124: 'HTTP Proxy',
  3127: 'MyDoom',
  3128: 'HTTP Proxy',
  3222: 'GLBP',
  3260: 'iSCSI Target',
  3306: 'MySQL',
  3389: 'Terminal Server',
  3689: 'iTunes',
  3690: 'Subversion',
  3724: 'Word of Warcreaft',
  3784: 'Ventrilo',
  3785: 'Ventrilo',
  4333: 'mSQL',
  4444: 'Blaster',
  4664: 'Google Desktop',
  4672: 'eMule',
  4899: 'Radmin',
  5000: 'UPnP',
  5001: 'iperf',
  5004: 'RTP',
  5005: 'RTP',
  5050: 'Yahoo! Messenger',
  5060: ' SIP',
  5190: 'AIM/ICQ',
  5222: 'XAMPP/Jabber',
  5223: 'XAMPP/Jabber',
  5432: 'PostgreSQL',
  5500: 'VNC Server',
  5554: 'Sasser',
  5631: 'pcAnywhere',
  5632: 'pcAnywhere',
  5800: 'VNC over HTTP',
  5900: 'VNC Server',
  6000: 'X11',
  6001: 'X11',
  6112: ' Battle.net',
  6129: 'DameWare',
  6257: 'WinMX',
  6346: 'Gnutella',
  6347: 'Gnutella',
  6500: 'GameSpy Arcade',
  6566: 'SANE',
  6588: 'AnalogX',
  6665: 'IRC',
  6666: 'IRC',
  6667: 'IRC',
  6668: 'IRC',
  6669: 'IRC',
  6679: 'IRC over SSL',
  6680: 'IRC over SSL',
  6681: 'IRC over SSL',
  6682: 'IRC over SSL',
  6683: 'IRC over SSL',
  6684: 'IRC over SSL',
  6685: 'IRC over SSL',
  6686: 'IRC over SSL',
  6687: 'IRC over SSL',
  6688: 'IRC over SSL',
  6689: 'IRC over SSL',
  6690: 'IRC over SSL',
  6691: 'IRC over SSL',
  6692: 'IRC over SSL',
  6693: 'IRC over SSL',
  6694: 'IRC over SSL',
  6695: 'IRC over SSL',
  6696: 'IRC over SSL',
  6697: 'IRC over SSL',
  6699: 'Napser',
  6881: 'BitTorrent',
  6882: 'BitTorrent',
  6883: 'BitTorrent',
  6884: 'BitTorrent',
  6885: 'BitTorrent',
  6886: 'BitTorrent',
  6887: 'BitTorrent',
  6888: 'BitTorrent',
  6889: 'BitTorrent',
  6890: 'BitTorrent',
  6891: 'Windows Live',
  6892: 'Windows Live',
  6893: 'Windows Live',
  6894: 'Windows Live',
  6895: 'Windows Live',
  6896: 'Windows Live',
  6897: 'Windows Live',
  6898: 'Windows Live',
  6899: 'Windows Live',
  6900: 'Windows Live',
  6901: 'Windows Live',
  6902: 'BitTorrent',
  6903: 'BitTorrent',
  6904: 'BitTorrent',
  6905: 'BitTorrent',
  6906: 'BitTorrent',
  6907: 'BitTorrent',
  6908: 'BitTorrent',
  6909: 'BitTorrent',
  6910: 'BitTorrent',
  6911: 'BitTorrent',
  6912: 'BitTorrent',
  6913: 'BitTorrent',
  6914: 'BitTorrent',
  6915: 'BitTorrent',
  6916: 'BitTorrent',
  6917: 'BitTorrent',
  6918: 'BitTorrent',
  6919: 'BitTorrent',
  6920: 'BitTorrent',
  6921: 'BitTorrent',
  6922: 'BitTorrent',
  6923: 'BitTorrent',
  6924: 'BitTorrent',
  6925: 'BitTorrent',
  6926: 'BitTorrent',
  6927: 'BitTorrent',
  6928: 'BitTorrent',
  6929: 'BitTorrent',
  6930: 'BitTorrent',
  6931: 'BitTorrent',
  6932: 'BitTorrent',
  6933: 'BitTorrent',
  6934: 'BitTorrent',
  6935: 'BitTorrent',
  6936: 'BitTorrent',
  6937: 'BitTorrent',
  6938: 'BitTorrent',
  6939: 'BitTorrent',
  6940: 'BitTorrent',
  6941: 'BitTorrent',
  6942: 'BitTorrent',
  6943: 'BitTorrent',
  6944: 'BitTorrent',
  6945: 'BitTorrent',
  6946: 'BitTorrent',
  6947: 'BitTorrent',
  6948: 'BitTorrent',
  6949: 'BitTorrent',
  6950: 'BitTorrent',
  6951: 'BitTorrent',
  6952: 'BitTorrent',
  6953: 'BitTorrent',
  6954: 'BitTorrent',
  6955: 'BitTorrent',
  6956: 'BitTorrent',
  6957: 'BitTorrent',
  6958: 'BitTorrent',
  6959: 'BitTorrent',
  6960: 'BitTorrent',
  6961: 'BitTorrent',
  6962: 'BitTorrent',
  6963: 'BitTorrent',
  6964: 'BitTorrent',
  6965: 'BitTorrent',
  6966: 'BitTorrent',
  6967: 'BitTorrent',
  6968: 'BitTorrent',
  6969: 'BitTorrent',
  6970: 'Quicktime',
  6971: 'BitTorrent',
  6972: 'BitTorrent',
  6973: 'BitTorrent',
  6974: 'BitTorrent',
  6975: 'BitTorrent',
  6976: 'BitTorrent',
  6977: 'BitTorrent',
  6978: 'BitTorrent',
  6979: 'BitTorrent',
  6980: 'BitTorrent',
  6981: 'BitTorrent',
  6982: 'BitTorrent',
  6983: 'BitTorrent',
  6984: 'BitTorrent',
  6985: 'BitTorrent',
  6986: 'BitTorrent',
  6987: 'BitTorrent',
  6988: 'BitTorrent',
  6989: 'BitTorrent',
  6990: 'BitTorrent',
  6991: 'BitTorrent',
  6992: 'BitTorrent',
  6993: 'BitTorrent',
  6994: 'BitTorrent',
  6995: 'BitTorrent',
  6996: 'BitTorrent',
  6997: 'BitTorrent',
  6998: 'BitTorrent',
  6999: 'BitTorrent',
  7212: 'GhostSurf',
  7648: 'CU-SeeMe',
  7649: 'CU-SeeMe',
  8000: 'Internet Radio',
  8080: 'HTTP Proxy',
  8086: 'Kaspersky AV',
  8087: 'Kaspersky AV',
  8118: 'Privoxy',
  8200: 'VMware Server',
  8500: 'Adobe ColdFusion',
  8767: 'TeamSpeak',
  8866: 'Bagle.B',
  9100: 'HP jetDirect',
  9101: 'Bacula',
  9102: 'Bacula',
  9103: 'Bacula',
  9119: 'MXit',
  9800: 'WebDAV',
  9898: 'Dabber',
  9988: 'Robot/Spybot',
  9999: 'Urchin',
  10000: 'Webmin',
  10113: 'NetIQ',
  10114: 'NetIQ',
  10115: 'NetIQ',
  10116: 'NetIQ',
  11371: 'OpenPGP',
  12035: 'Second Life',
  12036: 'Second Life',
  12345: 'NetBus',
  13720: 'NetBackup',
  13721: 'NetBackup',
  14567: 'Battlefield',
  15118: 'Dipnet/Oddbob',
  19226: 'AdminSecure',
  19638: 'Ensim',
  20000: 'Usermin',
  24800: 'Synergy',
  25999: 'Xfire',
  27015: 'Half-Life',
  27374: 'Sub7',
  28960: 'Call of Duty',
  31337: 'Back Orifice',
  33434: 'traceroute',
}

/** `TcpPortMatch`. null = port necunoscut. */
export function tcpPortName(port: string | number): string | null {
  const n = Number(port)
  return Number.isFinite(n) && TCP_PORTS[n] !== undefined ? TCP_PORTS[n] : null
}
